import { Field, useFormikContext } from "formik";
import React, { FC } from "react";
import allReportStatus from "../../constants/all-report-status";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { useLocale } from "../../contexts/localeContext";
import CardFormatImage from "../../images/CardFormatImage.svg";
import { validateItemName } from "../../utilities/Validation";
import EntityHierarchy from "../entityHierarchy/entityHierarchy";
import MaskInput from "../input/MaskInput";
import Label from "../label/label";
import Togglebox from "../togglebox/togglebox";

interface FormatCardProps {
    setCurrentItem: (item: any) => void;
}

export const FormatCard: FC<FormatCardProps> = ({setCurrentItem}) => {
    const { errors, values } = useFormikContext<any>();
    const { translate } = useLocale();

    return <>
        <div className="w-full p-2 inline-flex justify-start items-top bg-white">
            <div className="flex flex-row ml-8 mr-8 mt-6">
                <img
                    className="pr-2 w-40 h-auto"
                    src={CardFormatImage}
                    alt="Card Format" />
            </div>
            {values.id ?
                (<div className="flex flex-row mt-6">
                    <EntityHierarchy
                        title={values.name}
                        tree={{
                            label: translate.byKey(TranslationKeys.systemSite),
                            node: { label: values.name },
                        }} />
                </div>) : null}
            <div className="flex flex-row py-4 px-8">
                <div className="flex flex-col text-wrap">
                    <div className="mb-2">
                        <div className="flex flex-row justify-between">
                            <Label
                                htmlFor="name"
                                className="text-xs text-gray-600 mt-1"
                                required >
                                {translate.byKey(TranslationKeys.name)}:
                            </Label>
                            {errors.name ? (<span className="text-red-600 text-xs">{errors.name}</span>) : null}
                        </div>
                        <Field
                            type="text"
                            name="name"
                            className={`"flex flex-row items-center pr-2 pl-2 p-1 text-sm bg-gray-input w-full ${values.status === allReportStatus.Template.id ? "text-gray-500 cursor-not-allowed" : ""}"`}
                            disabled={values.status === allReportStatus.Template.id}
                            validate={(value) => validateItemName(value, translate)} />
                    </div>
                    <div className="mb-2">
                        <div className="flex flex-row justify-between">
                            <Label
                                htmlFor="tagMask"
                                className="text-xs text-gray-600 mt-1"
                                required >
                                {translate.byKey(TranslationKeys.cardTagMask)} :
                            </Label>
                            {errors.tagMask ? (<span className="text-red-600 text-xs pl-3">{errors.tagMask}</span>) : null}
                        </div>
                        <MaskInput setCurrentItem={setCurrentItem} name="tagMask" charactersPerField={2} numberOfFields={10} disabled={values.status === allReportStatus.Template.id} />
                    </div>
                    <div>
                        <div className="flex flex-row justify-between">
                            <Label
                                htmlFor="siteMask"
                                className="text-xs text-gray-600 mt-1"
                                required >
                                {translate.byKey(TranslationKeys.siteMask)}:
                            </Label>
                            {errors.siteMask ? (<span className="text-red-600 text-xs pl-3">{errors.siteMask}</span>) : null}
                        </div>
                        <MaskInput setCurrentItem={setCurrentItem} name="siteMask" charactersPerField={2} numberOfFields={10} disabled={values.status === allReportStatus.Template.id} />
                    </div>
                </div>
            </div>
            <div className="flex flex-row py-4 px-8">
                <div className="flex flex-col">
                    <div>
                        <div className="flex flex-row justify-between">
                            <Label
                                htmlFor="dropZero"
                                className="text-xs text-gray-600 mt-1 my-1">
                                {translate.byKey(TranslationKeys.cardTagMaskRemoveZeros)}:
                            </Label>
                        </div>
                        <div className="my-0">
                            <Togglebox
                                name="dropZero"
                                disabled={values.status === allReportStatus.Template.id}
                                label="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
};
